<template>
  <div class="TranActs">
    <div class="TranActs-background">
      <div class="AgstOpel-AppTitle">
        <img src="../../public/obraoag/NewCapeReturn.png" alt="" @click="BackLevel()">
        转账
      </div>
      <div class="TranActs-trnstype">
        <div class="TranActs-trnstype-conent TranActs-trnstype-line" :class="this.trnste == 1 ? 'TranActs-trnstype-select' : ''" @click="traspe(1)"><span>余额转账</span></div>
        <div class="TranActs-trnstype-conent" :class="this.trnste == 2 ? 'TranActs-trnstype-select' : ''" @click="traspe(2)"><span>积分转账</span></div>
      </div>
      <router-link :to="{path: 'cardnber',query: {trsabr: this.trchbr}}">
        <div class="TranActs-CardTion">
            <div class="TranActs-CardTion-left"></div>
            <div class="TranActs-CardTion-center">
            <p class="TranActs-CardTion-center-text">转账到一卡通账户</p>
            <p>{{this.trrmon ? this.trrmon : '请选择转入的卡号'}}</p>
            </div>
            <div class="TranActs-CardTion-right"></div>
        </div>
      </router-link>
      <router-link :to="{path: 'CardBag',query: {HoCardBag: '5',tracnt: this.trrmon}}">
        <div class="TranActs-outins">
            <span>转出卡号</span>
            <span>{{this.trchbr ? this.trchbr : '请选择'}}</span>
        </div>
      </router-link>
      <div class="TranActs-OpelNumber">
        <p class="TranActs-OpelNumber-text">转账欧宝</p>
        <div class="TranActs-OpelNumber-Recharge">
          <span>￥</span>
          <el-input type="Number" pattern="[0-9]*" v-model="Trtsarge" placeholder="请输入转账欧宝" clearable @input="Tranchge()"></el-input>
        </div>
      </div>
      <button class="TranActs-confirm" @click="trcorm()">确认</button>
      <div class="TranActs-reminder" v-show="isOriginHei">- 欧宝将实时转入对方账户,无法退款 -</div>
    </div>
    <!-- 失败提示 -->
    <div id="warnToast" :style="'display:' + tranfail">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-warn weui-icon_toast"></i>
        <p class="weui-toast__content">{{trantips}}</p>
      </div>
    </div>
    <!-- 成功提示 -->
    <div id="toast" :style="'display:' + transucs">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{trantips}}</p>
      </div>
    </div>
    <!-- 选择框 -->
    <div id="dialogs">
      <div class="js_dialog" id="iosDialog1" style="display: none;">
        <div class="weui-mask" @click="tranmask()"></div>
        <div id="js_dialog_1" class="weui-half-screen-dialog">
          <div class="weui-half-screen-dialog__hd">
            <div class="weui-half-screen-dialog__hd__side">
              <button class="weui-icon-btn" @click="tranmask()">关闭<i class="weui-icon-close-thin"></i></button>
            </div>
            <div class="weui-half-screen-dialog__hd__main">
              <strong class="weui-half-screen-dialog__title">请输入支付密码</strong>
            </div>
          </div>
          <div class="weui-half-screen-dialog__bd">
            <div class="CardDetails-paword">
              <el-input type="password" v-model="tranpsod" placeholder="请输入密码" clearable show-password @input="tranpard()"></el-input>
              <button @click="tranoptn()">确认</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TextTips></TextTips>
  </div>
</template>

<script>
import "./obraojs/rem"
export default {
  data () {
    return{
      Trtsarge: '',
      trnste: 1,
      loginID: '',
      trchbr: '',
      trrmon: '',
      tranfail: 'none',
      trantips: '',
      transucs: 'none',
      tranpsod: '',
      isOriginHei: true,
      screenHeight: document.documentElement.clientHeight,
      originHeight: document.documentElement.clientHeight
    }
  },
  created () {
    // 从缓存里获取token
    this.loginID = localStorage.getItem("usertoken");
    // 接收选择卡号(卡包、转到一卡通账户)传过来的卡号
    this.trchbr = this.$route.query.sechbr;
    // 接收转到一卡通账户传过来的卡号
    this.trrmon = this.$route.query.carmon;
  },
  mounted () {
    let that = this;
    window.onresize = function() {
      return (function(){
        that.screenHeight = document.documentElement.clientHeight;
      })()
    }
  },
  watch:{
    screenHeight (val) {
      if(this.originHeight > val + 100) {        //加100为了兼容华为的返回键
        this.isOriginHei = false;
      }else{
        this.isOriginHei = true;
      }
    }
  },
  methods: {
    // 获取用户选择的转账类型
    traspe(trtype){
      this.trnste = trtype
    },
    // 获取要充值的欧宝数
    Tranchge(){
      console.log(this.Trtsarge);
    },
    // 点击确认调起支付框
    trcorm(){
      if(!this.trrmon){
        this.trantips = '转入卡号不能为空';
        this.tranfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.tranfail = 'none';
        },1200)
      }else if(this.trchbr == ''){
        this.trantips = '转出卡号不能为空';
        this.tranfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.tranfail = 'none';
        },1200)
      }else if(this.Trtsarge == ''){
        this.trantips = '转账金额不能为空';
        this.tranfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.tranfail = 'none';
        },1200)
      }else{
        this.$('#js_dialog_1').addClass('weui-half-screen-dialog_show');
        this.$('#iosDialog1').fadeIn(200);
      }
    },
    // 点击遮罩层或者关闭按钮时输入支付密码弹框消失
    tranmask(){
      this.$('#js_dialog_1').removeClass('weui-half-screen-dialog_show');
      this.$('#iosDialog1').fadeOut(200);
      this.tranpsod = ''
    },
    // 获取用户输入的密码
    tranpard(){
      // console.log(this.tranpsod);
    },
    // 点击确认进行转账操作
    tranoptn(){
      if(this.tranpsod == ''){
        this.trantips = '支付密码不能为空';
        this.tranfail = 'block';
        const _this = this;
        setTimeout(function(){
          _this.tranfail = 'none';
        },1200)
      }else{
        this.$axios.post('app/transfer',this.$qs.stringify({
          token: this.loginID,
          transfertype: this.trnste,
          amtoritl: this.Trtsarge,
          cnumber: this.trchbr,
          cpassword: this.tranpsod,
          transfernumber: this.trrmon
        }),{headers:{'token': this.loginID}})
        .then(res => {
          if(res.data.code == '200'){
            this.trantips = res.data.msg;
            this.transucs = 'block';
            const _this = this;
            setTimeout(function(){
              _this.transucs = 'none';
              _this.Trtsarge = '';
            },1200)
          }else{
            this.trantips = res.data.msg;
            this.tranfail = 'block';
            const _this = this;
            setTimeout(function(){
              _this.tranfail = 'none';
            },1200)
          }
        })
        .catch(() => {
          console.log('获取失败');
        });
      }
      this.$('#js_dialog_1').removeClass('weui-half-screen-dialog_show');
      this.$('#iosDialog1').fadeOut(200);
      this.tranpsod = ''
    },
    // 返回上一层
    BackLevel(){
      this.$router.push({name: 'HomePage'});
    }
  }
}
</script>

<style scoped>
  @import "obraocs/TranActs.css";
</style>